const container = document.getElementById('root');
const dataset = container?.dataset;
const { backendUrl } = dataset ?? {};

const BACKEND_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : backendUrl;

export default BACKEND_URL;
